/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_order_steps_ordered = /** @type {(inputs: { date: NonNullable<unknown> }) => string} */ (i) => {
	return `Objednáno ${i.date}`
};

const da_order_steps_ordered = /** @type {(inputs: { date: NonNullable<unknown> }) => string} */ (i) => {
	return `Bestilt den ${i.date}`
};

const de_order_steps_ordered = /** @type {(inputs: { date: NonNullable<unknown> }) => string} */ (i) => {
	return `Bestellt am ${i.date}`
};

const en_order_steps_ordered = /** @type {(inputs: { date: NonNullable<unknown> }) => string} */ (i) => {
	return `Ordered on ${i.date}`
};

const es_order_steps_ordered = /** @type {(inputs: { date: NonNullable<unknown> }) => string} */ (i) => {
	return `Pedido el ${i.date}`
};

const fr_order_steps_ordered = /** @type {(inputs: { date: NonNullable<unknown> }) => string} */ (i) => {
	return `Commandé le ${i.date}`
};

const hu_order_steps_ordered = /** @type {(inputs: { date: NonNullable<unknown> }) => string} */ (i) => {
	return `Megrendelt: ${i.date}`
};

const it_order_steps_ordered = /** @type {(inputs: { date: NonNullable<unknown> }) => string} */ (i) => {
	return `Ordinato il ${i.date}`
};

const nl_order_steps_ordered = /** @type {(inputs: { date: NonNullable<unknown> }) => string} */ (i) => {
	return `Besteld op ${i.date}`
};

const pl_order_steps_ordered = /** @type {(inputs: { date: NonNullable<unknown> }) => string} */ (i) => {
	return `Zamówiono ${i.date}`
};

const pt_order_steps_ordered = /** @type {(inputs: { date: NonNullable<unknown> }) => string} */ (i) => {
	return `Pedido feito em ${i.date}`
};

const sv_order_steps_ordered = /** @type {(inputs: { date: NonNullable<unknown> }) => string} */ (i) => {
	return `Beställd den ${i.date}`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ date: NonNullable<unknown> }} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const order_steps_ordered = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.order_steps_ordered(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("order_steps_ordered", locale)
	if (locale === "cs") return cs_order_steps_ordered(inputs)
	if (locale === "da") return da_order_steps_ordered(inputs)
	if (locale === "de") return de_order_steps_ordered(inputs)
	if (locale === "en") return en_order_steps_ordered(inputs)
	if (locale === "es") return es_order_steps_ordered(inputs)
	if (locale === "fr") return fr_order_steps_ordered(inputs)
	if (locale === "hu") return hu_order_steps_ordered(inputs)
	if (locale === "it") return it_order_steps_ordered(inputs)
	if (locale === "nl") return nl_order_steps_ordered(inputs)
	if (locale === "pl") return pl_order_steps_ordered(inputs)
	if (locale === "pt") return pt_order_steps_ordered(inputs)
	return sv_order_steps_ordered(inputs)
};
export { order_steps_ordered as "order_steps.ordered" }